<template>
    <div>
        <app-nav/>
        <main>
            <section>
                <div class="row d-flex justify-content-center m-0 p-0 ">
                    <div class="col taust w-100">
                        <div class="row d-flex mob-bg justify-content-center m-0 p-0 wow fadeIn">
                            <div class="col top-m-p text-center w-100">
                                <h1 class="display-5 font-weight-normal my-3">
                                    {{ $t('Vehicles') }}
                                </h1>
                            </div>
                        </div>
                        <div class="container m-auto p-0" id="hinnatabel" v-if="publicVehicles.length">
                            <div class="dtHinnadWrapper table-responsive">
                                <table class="dtHinnad table table-hover table-striped table-sm w-100">
                                    <thead>
                                        <tr class="table-info">
                                            <th class="sticky-top text-center" scope="col" colspan="2">
                                                {{ $t('Vehicle') }}
                                            </th>
                                            <th class="sticky-top text-center" scope="col" colspan="6">
                                                {{ $t('Prices') }}
                                            </th>
                                        </tr>
                                        <tr class="table-info">
                                            <th class="sticky-top text-center" scope="col" colspan="2"></th>
                                            <th class="sticky-top p-0" scope="col" v-for="(price, jn) in publicVehicles[0].prices" :key="jn">
                                                <p class="m-0">{{ price.range.min === 0 ? price.range.min + 1 : price.range.min }}-{{ price.range.max | valueOrDots }} {{ $t('days') }}</p>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(vehicle, i) in publicVehicles" :key="i">
                                            <th scope="row" style="width: 10%" class="p-1">
                                                <img v-if="vehicle.imgs.length" :src="`${envUrl}/vehicles/${vehicle.imgs[0].dbname}`" height="auto" class="img-thumbnail rounded z-depth-1"/>
                                                <div v-else class="card-image rounded z-depth-1">
                                                    <div class="view car-img pointer" />
                                                </div>
                                            </th>
                                            <th scope="row">
                                                <router-link :to="{ name: 'pub.booking', params: { vehicle_slug: vehicle.slug } }" tag="a">
                                                    {{ vehicle.make.name }} {{ vehicle.model.name }} <app-vehicle-no :slug="vehicle.slug"/> <small>({{ $t(vehicle.transmission.name) }})</small>
                                                </router-link>
                                            </th>
                                            <th scope="row" v-for="(price, j) in vehicle.prices" :key="j">
                                                <p class="m-0">
                                                    <template v-if="price.discount_price">
                                                        <span style="text-decoration: line-through">
                                                            {{ price.price / 100 }} <small>EUR/{{ $t('day') }}</small><br>
                                                        </span>
                                                        <span class="text-danger">
                                                            {{ price.discount_price / 100 }} <small>EUR/{{ $t('day') }}</small>
                                                        </span>
                                                    </template>
                                                    <template v-else>
                                                        {{ price.price / 100 }} <small>EUR/{{ $t('day') }}</small>
                                                    </template>
                                                </p>
                                            </th>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <app-loader-svg class="mt-4" v-if="!publicVehicles.length"/>
                    </div>
                </div>
            </section>
        </main>
        <app-footer/>
    </div>
</template>

<script>
import AppNav from '@components/layout/public/Nav';
import AppFooter from '@components/layout/public/Footer';
import PublicPageService from '@services/publicPage.service';
import {mapGetters} from 'vuex';

export default {
    computed: {
        ...mapGetters(['envUrl', 'locale', 'publicVehicles']),
    },
    components: {
        AppNav,
        AppFooter
    },
    created() {
        this.$store.dispatch('GET_PUBLIC_VEHICLES');
    }
};
</script>
